export const cacheImages = async (srcArray) => {
  const promises = srcArray.map(async src => new Promise((resolve, reject) => {
    const img = new Image()
    img.src = src
    img.onload = resolve
    img.onerror = reject
  }))
  await Promise.all(promises)
}